import React from 'react'
import { Tag as TagComponent, Events, type EventDetails } from '../zaptic-tag'
import { createComponent, type EventName } from '@lit-labs/react'

export const Tag = createComponent(React, 'zaptic-tag', TagComponent, {
    onClick: Events.click as EventName<CustomEvent<EventDetails[Events.click]>>,
    onRemove: Events.remove as EventName<CustomEvent<EventDetails[Events.remove]>>,
})
